export const LATEST_REVIEWS = `
query latestReviews($count: Int = 3, $minRating: Int = 5, $target: [ReviewTarget!]) {
  reviews(
    first: $count
    orderBy: date_DESC
    where: {target_in: $target, rating_gte: $minRating}
  ) {
    id
    author
    date
    rating
    review
  }
}
`;
